import { ClubModel } from '@modules/club/club-model';

const { fields } = ClubModel;

export default [
  fields.id,
  fields.name,
  fields.teams,
  fields.createdAt
];
